import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import Swiper, { SwiperArrowType } from '@deporvillage/swiper-component';

import styles from './TopBrands.module.scss';

const Type = {
    Default: 'default',
    Alternative: 'alternative',
};

const TopBrandsClick = {
    BrandItem: 'brand',
    ShowMore: 'more',
};

const TopBrandItem = ({ idx, url, name, image_bw, image, onClick }) => (
    <a
        key={url}
        data-testid={`top-brand-anchor-${idx}`}
        title={name}
        href={url}
        onClick={() => onClick && onClick()}
    >
        <Picture key={url} src={`brand/logo/bw/${image_bw || image}`} name={name} width={78} height={78} lazy/>
    </a>
);
TopBrandItem.propTypes = {
    idx: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    onClick: PropTypes.func,
    // Deprectated - use `image` instead
    image_bw: PropTypes.string,
};

const TopBrandsExtended = ({ items, type, onClick }) => {

    const [hidden, setHidden] = React.useState(true);
    const [isButtonHidden, setIsButtonHidden] = React.useState(true);
    const [numberOfItemsToShow, setNumberOfItemToShow] = React.useState(12);

    const listContent = React.useRef(null);
    const showContent = React.useRef(null);

    const toggle = () => {
        setNumberOfItemToShow(hidden ? items.length : 12);
        setHidden(!hidden);
    };

    const checkButtonVisibility = () => {
        if (items.length) setIsButtonHidden(listContent.current.getBoundingClientRect().right < showContent.current.getBoundingClientRect().left - 70);
    };

    React.useEffect(() => {
        checkButtonVisibility();
    }, []);

    return items.length ? (
        <div className={`${styles['top-brands-extended-component']} ${styles[type || Type.Default]}`} onClick={checkButtonVisibility}>
            <div data-testid={'top-brands-list'} ref={listContent} className={`${styles.list} ${!hidden ? styles.visible : ''} ${isButtonHidden ? styles['one-row'] : ''}`}>
                {
                    items.map((i, idx) => (
                        idx < numberOfItemsToShow && (
                            <TopBrandItem
                                key={i.url} 
                                {...i} 
                                idx={idx}
                                onClick={() => onClick && onClick(TopBrandsClick.BrandItem)}
                            />
                        )
                    ))
                }
            </div>
            <span ref={showContent}>
                <span
                    className={`${styles['show-more']}`}
                    data-testid='top-brands-show-more'
                    onClick={() => toggle() || onClick && onClick(TopBrandsClick.ShowMore)}
                >
                    <span className={`icon ${hidden ? 'icon-more' : 'icon-less'}`} />
                </span>
            </span>
        </div>) : null;
};
TopBrandsExtended.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.string,
            url: PropTypes.string,
            // Deprectated - use `image` instead
            image_bw: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
};

const TopBrands = ({ items, type, url, breakpoints, onClick }) => (items.length ?
    <div className={`${styles['top-brands-component']} ${styles[type || Type.Default]}`}>

        <div className={styles.list}>
            <Swiper arrows={SwiperArrowType.None} multiple breakpoints={breakpoints}>
                {items.map((i, idx) =>
                    <TopBrandItem key={i.url} {...i} idx={idx}
                        onClick={ /* istanbul ignore next */ () => onClick && onClick(TopBrandsClick.BrandItem)} />)}
            </Swiper>
        </div>
        <a className={styles['show-more']}
            data-testid='top-brands-show-more'
            onClick={() => onClick && onClick(TopBrandsClick.ShowMore)}
            href={url}>
            <span className={'icon icon-more'} />
        </a>

    </div> : null
);
TopBrands.propTypes = {
    url: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.string,
            url: PropTypes.string,
            // Deprectated - use `image` instead
            image_bw: PropTypes.string,
        })
    ),
    breakpoints: PropTypes.object,
    onClick: PropTypes.func,
};

export default TopBrands;
export {
    TopBrandsExtended,
    TopBrandsClick,
    Type as TopBrandsType,
};
